import React, { useState, useEffect } from "react";
import { Box, Button, Checkbox, FormControlLabel, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TestOption from "../compnents/TestOption";
import FileUploader from "@jumbo/Dashboards/Media/FileUploader";
import TestTitle from "../compnents/TestTitle";
import ImagePicker from "../compnents/ImagePicker";
import ImgaeSelector from "../compnents/ImgaeSelector";
import DifferencePointer from "../compnents/DifferencePointer";
import { Add, Edit, Delete } from "@material-ui/icons";
import TestsRequests from "services/tests";
import { useDispatch } from "react-redux";
import AddQuesitonDialog from "../compnents/AddQuesitonDialog";
import RemoveQuesitonDialog from "../compnents/RemoveQuestionDialog";
import UpdateQuesitonDialog from "../compnents/UpdateQuestionDialog";
import { fetchError } from "redux/actions";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    marginTop: 10,
  },
  answerSelctText: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "12px",
  },
}));

const DifferenceQuestionElement = ({ question, quizId }) => {
  const classes = useStyles();
  const [openFileUploader, setOpenFileUploader] = useState(false);
  const [questoinTitle, setQuestoinTitle] = useState("");
  const [cover, setCover] = useState("");
  const [score, setScore] = useState(15);
  const [exposed, setExposed] = useState(false);
  const [differnceFirstImg, setDiffernceFirstImg] = useState("");
  const [differenceSecondImg, setdifferenceSecondImg] = useState("");
  const [differncePoints, setDifferncePoints] = useState([]);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (question) {
      setQuestoinTitle(question.title);
      setScore(question.score);
      setCover(question?.cover);
      setExposed(question?.exposed);
      setDiffernceFirstImg(question?.optionsDifferenceImage1);
      setdifferenceSecondImg(question?.optionsDifferenceImage2);
      setDifferncePoints(
        question?.optionsDifference
          ? question.optionsDifference.map((item, index) => ({
            id: index + 1,
            x: item.split("|")[0],
            y: item.split("|")[1],
          }))
          : []
      );
    }
  }, [question]);

  const handleAddQuesiton = () => {
    let QusetionData = {
      difficulty: "common",
      cover: cover,
      score: score,
      exposed: exposed,
      title: questoinTitle,
      type: "difference",
      quizId: quizId,
    };
    QusetionData["optionsDifferenceImage1"] = differnceFirstImg;
    QusetionData["optionsDifferenceImage2"] = differenceSecondImg;
    QusetionData["optionsDifference"] = differncePoints;
    dispatch(TestsRequests.addSingleQuestion(QusetionData))
      .then(() => {
        setQuestoinTitle("");
        setCover("");
        setDiffernceFirstImg("");
        setdifferenceSecondImg("");
        setDifferncePoints([]);
      })
      .catch((err) => {
        dispatch(fetchError(err));
      });
    setOpenAddDialog(false);
  };

  const handleRemoveAndClose = () => {
    dispatch(TestsRequests.removeSingleQuestion(question._id));
    setOpenRemoveDialog(false);
  };

  const handleEditAndClose = () => {
    let QusetionData = {
      difficulty: "common",
      cover: cover,
      score: score,
      exposed: exposed,
      title: questoinTitle,
      type: "difference",
      quizId: quizId,
    };
    QusetionData["optionsDifferenceImage1"] = differnceFirstImg;
    QusetionData["optionsDifferenceImage2"] = differenceSecondImg;
    QusetionData["optionsDifference"] = differncePoints;
    dispatch(TestsRequests.updateSingleQuestion(question._id, QusetionData));
    setOpenUpdateDialog(false);
  };

  return (
    <React.Fragment>
      <TestTitle
        value={questoinTitle}
        handeChange={(value) => setQuestoinTitle(value)}
      />
      <Grid item xs={12}>
        <Typography className={classes.answerSelctText}>
          انتخاب تصویر سوال
        </Typography>
        <ImagePicker
          cover={cover}
          handlePick={() => setOpenFileUploader(true)}
          handleRevome={() => setCover("")}
          previewStyles={{ marginInline: "auto", marginBlock: "20px" }}
          placeHolderStyles={{ marginInline: "auto", marginBlock: "20px" }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography className={classes.answerSelctText}>
          انتخاب تصویر اصلی
        </Typography>
        <ImgaeSelector
          puzzleSource={differnceFirstImg}
          setPuzzleSource={setDiffernceFirstImg}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography className={classes.answerSelctText}>
          انتخاب تصویر متفاوت
        </Typography>
        <ImgaeSelector
          puzzleSource={differenceSecondImg}
          setPuzzleSource={setdifferenceSecondImg}
        />
      </Grid>
      <Grid item xs={12}>
        {differenceSecondImg ? (
          <DifferencePointer
            src={differenceSecondImg}
            points={differncePoints}
            setPoints={setDifferncePoints}
          />
        ) : null}
      </Grid>
      <TestOption
        text={""}
        title={"پله"}
        type={"number"}
        value={score}
        handleChange={(value) => setScore(+value)}
      />
      <Grid item xs={12} style={{ marginTop: "16px" }}>
        <FormControlLabel 
          control={
            <Checkbox
              checked={exposed}
              onChange={(e) => setExposed(e.target.checked)}
              color="primary"
            />
          }
          label="لو رفته"
        />
      </Grid>

      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={(selected) => setCover(selected)}
        selectedItem={cover}
        imageSelector={true}
      />
      <Box className={classes.actionsContainer}>
        {question ? (
          <>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Delete />}
              onClick={() => setOpenRemoveDialog(true)}
              style={{ marginRight: 14 }}
            >
              حذف
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Edit />}
              onClick={() => setOpenUpdateDialog(true)}
              style={{ marginRight: 14 }}
            >
              ویرایش
            </Button>
          </>
        ) : (
          <Button
            variant="outlined"
            color="primary"
            startIcon={<Add />}
            onClick={handleAddQuesiton}
          >
            اضافه کردن سوال
          </Button>
        )}
      </Box>
      <AddQuesitonDialog
        open={openAddDialog}
        handleClose={() => setOpenAddDialog(false)}
        action={handleAddQuesiton}
      />
      <RemoveQuesitonDialog
        open={openRemoveDialog}
        handleClose={() => setOpenRemoveDialog(false)}
        action={handleRemoveAndClose}
      />
      <UpdateQuesitonDialog
        open={openUpdateDialog}
        handleClose={() => setOpenUpdateDialog(false)}
        action={handleEditAndClose}
      />
    </React.Fragment>
  );
};

export default DifferenceQuestionElement;
